<input id="lot-text-input-field"  #inputShares [value]="params.value ?? ''" (keypress)="validateInput($event)" (keydown)="onkeydown($event)" (focus)="onFocus($event)" (blur)="onBlur()"
    [ngClass]="showIcon ? 'errorClass sdps-input sdps-input--small ' : 'sdps-input sdps-input--small '"
    [class.aligned-render-input]="params?.mode === 'render'" />
<div class="tooltip-section" [class.tooltip-section--hidden]="!showIcon" [attr.aria-hidden]="!showIcon">
    <span class="errorText" id="errorText">{{toolTipErrorQuantiyMessage}}</span>
    <span 
        matTooltip="{{toolTipError}}" 
        matTooltipPosition="after"
        matTooltipClass="tooltip-content"
        class="sac-tooltip-icon">
    </span>
</div>